module.exports = __webpack_public_path__ + "img/OutputValuePerAcre.042b2de1.png";